/**
 *
 * Notifier
 * https://github.com/iamhosseindhv/notistack/tree/master/examples/redux-example
 */

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useSnackbar } from 'notistack';

import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectNotifications } from './selectors';
import { removeSnackbar } from './actions';
import reducer from './reducer';

export const Notifier = props => {
  const { removeSnackbar, notifications } = props;
  const [displayed, setDisplayed] = useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (notifications.length > 0) {
      notifications.forEach(({ key, message, options = {}, dismissed }) => {
        // Close snackbar when dismissed is present
        if (dismissed) {
          closeSnackbar(key);
          removeSnackbar(key);
        }
        // Do nothing if snackbar is already displayed
        if (displayed.includes(key)) return;

        if (message !== 'noError') {
          // Display snackbar using notistack
          enqueueSnackbar(message, {
            ...options,
            onClose: (event, reason, key) => {
              if (options.onClose) {
                options.onClose(event, reason, key);
              }
              // Dispatch action to remove snackbar from redux store
              removeSnackbar(key);
            },
          });
        } else {
          closeSnackbar(key);
        }

        // Keep track of snackbars that we've displayed
        setDisplayed([...displayed, key]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);
  // @dev useInjectReducer should always be after hooks function
  useInjectReducer({ key: 'notifier', reducer });

  return null;
};

Notifier.propTypes = {
  removeSnackbar: PropTypes.func.isRequired,
  notifications: PropTypes.array,
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    notifications: makeSelectNotifications(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    removeSnackbar: key => dispatch(removeSnackbar(key)),
  };
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect)(Notifier);
